export default __webpack_public_path__ + "static/media/tailwindcss.8b3f5baf.svg";